import { render, staticRenderFns } from "./infoSlave.vue?vue&type=template&id=7a3125cd&scoped=true"
import script from "./infoSlave.vue?vue&type=script&lang=js"
export * from "./infoSlave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3125cd",
  null
  
)

export default component.exports